import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

export const dateMaskPipe = createAutoCorrectedDatePipe('dd/mm/yyyy');
export const timeMaskPipe = createAutoCorrectedDatePipe('HH:MM');

